// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__96KW3","Main__Title":"Header_Main__Title__gXlFQ","Description":"Header_Description__0NFTM","Header__Image":"Header_Header__Image__t3e4u"};